import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const variants = {
  enter: {
    opacity: 1,
    transition: {
      delay: 0.3,
    },
  },
  exit: {
    opacity: 0,
  },
};

type Props = {
  trigger: React.Key;
};

export const FadeAnimationComponent: React.FC<Props> = (props) => {
  const { children, trigger } = props;

  return (
    <AnimatePresence>
      <motion.div
        key={trigger}
        variants={variants}
        initial="exit"
        animate="enter"
        exit="exit"
        transition={{
          type: 'spring',
          duration: 0,
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
